import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = "education_type";

export class EducationTypeApi extends BaseAPI {
    static list(): Promise<AxiosResponse> {
        return this.api.get(`${path}`)
    }
}

